module.exports = require("core-js/modules/es.object.get-prototype-of");